export type Theme = 'light' | 'dark';

type ThemeStyles = {
  bg: string;
  card: string;
  cardBorder: string;
  text: string;
  textSecondary: string;
  border: string;
  hover: string;
  accent: string;
  barBg: string;
};

export const getThemeStyles = (theme: Theme): ThemeStyles => ({
  bg: theme === 'dark' ? 'bg-[#0d1117]' : 'bg-[#f6f8fa]',
  card: theme === 'dark' ? 'bg-[#161b22]' : 'bg-white',
  cardBorder: theme === 'dark' ? 'border-[#21262d]' : 'border-[#d0d7de]',
  text: theme === 'dark' ? 'text-[#e6edf3]' : 'text-[#1f2328]',
  textSecondary: theme === 'dark' ? 'text-[#7d8590]' : 'text-gray-600',
  border: theme === 'dark' ? 'border-[#21262d]' : 'border-[#d0d7de]',
  hover: theme === 'dark' ? 'hover:border-[#00d4aa]' : 'hover:border-blue-400',
  accent: theme === 'dark' ? 'text-[#00d4aa]' : 'text-blue-600',
  barBg: theme === 'dark' ? 'bg-[#1c2330]' : 'bg-gray-200',
});